import { Box, Divider } from '@mui/material';
import { Typography } from 'components';

type TitleSessionProps = {
  title: string;
};

export const TitleSession = ({ title }: TitleSessionProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, mb: 1.5 }}>
      <Typography color="grey.200" sx={{ fontSize: 14, fontWeight: 600 }}>
        {title}
      </Typography>
      <Divider sx={{ flex: 1 }} />
    </Box>
  );
};
